module.exports = __webpack_public_path__ + "static/media/mc_screen_hover.e2dbb306.svg";